import { render, staticRenderFns } from "./DoubleSideTriangleHorizontal.vue?vue&type=template&id=1e1711fc&scoped=true&"
import script from "./DoubleSideTriangleHorizontal.vue?vue&type=script&lang=js&"
export * from "./DoubleSideTriangleHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1711fc",
  null
  
)

export default component.exports